import Button from 'carbon-react/lib/components/button';
import { useNavigate } from 'react-router';
import NotFoundImage from '../../assets/img/not-found.png';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const goBackAction = () => {
    const hasHistory: boolean =
      window.history.state && window.history.state.idx > 0;
    if (hasHistory) navigate(-1);
    navigate('/');
  };

  return (
    <div className="not-found-page">
      <div className="left-content">
        <div className="title">
          <span>Sorry, this page isn't available.</span>
        </div>
        <div className="subtitle">
          <span>
            The link you followed may be broken, or the page may have been
            removed.
          </span>
        </div>
        <Button buttonType="primary" onClick={goBackAction}>
          <span>Go back</span>
        </Button>
      </div>
      <div className="right-content">
        <img src={NotFoundImage} alt="page not found asset" />
      </div>
    </div>
  );
};

export default NotFoundPage;
